// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"87":"bdded2021ae6efe40628","123":"3f0e9a4170dbe64f3ccd","207":"adf1af6a4cb8ddde2182","324":"8f4ecdd0538da6f5212b","556":"19fa9d3affd83bab21eb","923":"a2f85ca8dd7d16ad42f8"}[chunkId] + ".bundle.js";
};